import { mobilePageTitleAtom } from 'config/store'
import { useAtom } from 'jotai'
import { useEffect, useState } from 'react'
import { Container, Dropdown, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import dropdownIcon from 'assets/images/arrow-down.svg'
import { makeData } from 'utils/makeData'

function IntroduceMobile({ title }) {
	const { t } = useTranslation()

	const gameData = makeData('game', 5)

	const [, setMobilePageTitle] = useAtom(mobilePageTitleAtom)
	useEffect(() => {
		setMobilePageTitle(title)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const [game, setGame] = useState(gameData?.[0]?.game)
	const [gameDesc, setGameDesc] = useState(gameData?.[0]?.desc)
	function handleGame(title, desc) {
		console.log('title, desc', title, desc)
		setGame(title)
		setGameDesc(desc)
	}

	return (
		<Container fluid className="px-sm-5">
			<Row>
				<Dropdown
					align="end"
					className="profilepage-content__body introduce-dropdown my-3"
				>
					<Dropdown.Toggle>{game}</Dropdown.Toggle>
					<Dropdown.Menu>
						{gameData?.map(item => {
							return (
								<Dropdown.Item
									key={item?.id}
									onClick={item => {
										console.log('item', item?.game)
										handleGame(item?.game, item?.desc)
									}}
								>
									{item?.game}
								</Dropdown.Item>
							)
						})}
					</Dropdown.Menu>
					<img src={dropdownIcon} alt="Dropdown games's introduce" />
				</Dropdown>
			</Row>
			<Row
				className="profilepage-content__body"
				style={{ border: 'none', background: 'none', textAlign: 'justify' }}
			>
				{gameDesc}
			</Row>
		</Container>
	)
}

export default IntroduceMobile
